<template>
  <div class="row">
    <div class="col-12">
      <card-filter
        @setupTable="setupTable"
        @filter="handleFilter"
        @showHideLoading="showHideLoading"
      />
      <card v-if="tableData.length > 0">
        <br />
        <div v-if="isIndex()">
          <card-header
            :propPagination="pagination"
            @searchedQuery="searchedQuery"
            class="mr-3 mt-1"
          ></card-header>
          <master-table
            :objectSpanMethod="objectSpanMethod"
            :cellStyle="handleCellStyle"
            :infoTable="queriedData"
            :columns="tableColumns"
            :defaultSort="{ prop: 'worker_code', order: 'ascending' }"
            :showColumnStatus="false"
          />
        </div>
        <not-index-permissions v-else />
        <card-footer ref="cardfooter" :propPagination="pagination" />
        <div class="mt-3">
          <div class="align-exportable">
            <div class="px-3" v-if="isPDF()">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="exportToPDFHeader"
              >
                <em class="fa fa-file-pdf-o"></em>
                {{ $t('common_words.export_to_pdf') }}
              </button>
            </div>
            <div class="px-3" v-if="isExcel()">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="exportXLSHeader()"
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_excel') }}
              </button>
            </div>
            <div class="px-3">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                style="
                  background-color: #0079c1 !important;
                  border-color: #0079c1 !important;
                "
                @click="exportToSAP()"
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_sap') }}
              </button>
            </div>
          </div>
        </div>
        <br />
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Pagination as LPagination } from 'src/components/index';
import CardFilter from './CardFilter.vue';
import configTable from './special-day-assistance-table';
import Fuse from 'fuse.js';
import i18n from 'src/i18n';
import MixinExportSpecialDayAssistance from './mixin-export-special-day-assistance';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';
import MixinGroupData from './mixin-group-data';

export default {
  components: {
    [CardFilter.name]: CardFilter,
    LPagination,
  },
  data() {
    return {
      dataFilter: {},
      model: null,
      tableColumns: [],
    };
  },
  mixins: [
    MixinMasters,
    MixinMenu,
    MixinPermissions,
    MixinExportSpecialDayAssistance,
    MixinGroupData,
  ],
  watch: {
    '$i18n.locale': ['setupTable'],
  },
  computed: {
    getDataToExport() {
      const response = {
        data: { ...this.tableData },
      };
      delete response.route;

      return response;
    },
    calculateSpanPagination() {
      return this.preprocessDataPagination(
        this.queriedData,
        ['fortnight_name', 'worker_code', 'farm_name'],
        'rowSpanPagination'
      );
    },
  },
  methods: {
    handleCellStyle({ row }) {
      if (
        Number(row.days) > Number(row.payment_limit) ||
        Number(row.days) === 0
      ) {
        return 'background-color: #fde6e4;';
      }

      return '';
    },
    handleFilter(data) {
      const moduleUrl = sessionStorage.getItem('urlModule');
      const modules = JSON.parse(sessionStorage.getItem('levelThree'));
      const moduleFind = modules.find(
        ({ url }) => `/${url}` === (moduleUrl ? moduleUrl : '')
      );

      this.dataFilter = {
        ...this.dataFilter,
        ...data,
        module_id: moduleFind ? moduleFind.id : 1,
      };
      this.getDataSamples();
    },
    getDataSamples() {
      this.showHideLoading(true);
      let data = this.dataFilter;
      data.route = 'works/specialdayassistance';
      Axios.postMasters(data)
        .then((response) => {
          this.tableData = response.data.data;
          if (this.tableData.length == 0) {
            SweetAlert.warning(i18n.t('sweet_alert.jobs.unavailable_data'));
          } else {
            this.numberColumnIndex = 3;
            this.tableData = this.preprocessData(this.tableData, [
              'fortnight_name',
              'worker_code',
              'farm_name',
            ]);
            this.fuseSearch = new Fuse(this.tableData, {
              useExtendedSearch: true,
              threshold: 0.3,
              keys: this.tableColumns.map((prop) => {
                return prop.prop;
              }),
            });
            this.pagination.perPage = 50;
            this.pagination.currentPage = 1;
            this.searchQuery = '';
          }

          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    setupTable() {
      const { Table } = configTable();
      this.pagination = { ...Table.pagination };
      this.tableColumns = Table.tableColumns;
      this.pagination.perPage = 5;
      this.pagination.currentPage = 1;
    },
  },
  mounted() {
    this.selectedItemOnMenu('works/laborheader');
  },
  destroyed() {
    this.deselectedItemOnMenu('works/laborheader');
  },
};
</script>
